if (window.location.pathname.includes("/cart")) {
  const loop = setInterval(() => {
    const btnCheckout = document.querySelector(`.cart-order button[name="checkout"][bss-b2b-cart-trigger-added]`);
    
    if (btnCheckout) {
      btnCheckout.style.pointerEvents = 'unset';
      btnCheckout.style.opacity = '1';
      clearInterval(loop);
    }
  }, 100);

  setTimeout(() => {
    clearInterval(loop);
    const btnCheckout = document.querySelector("button[name='checkout']");
    if (btnCheckout) {
      btnCheckout.style.pointerEvents = 'unset';
      btnCheckout.style.opacity = '1';
    }
  }, 4000);
}
